export default __webpack_public_path__ + "d2648e777b1916899f09b8d6ec9a791c.svg";